import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useQuery } from "@tanstack/react-query";
import { MarkdownRender } from "@/components/ui/markdown-render";

export function Privacy() {
  const { data: markdown, isLoading, error } = useQuery({
    queryKey: ["privacy-policy-markdown"],
    queryFn: async () => {
      const res = await fetch("/api/docs/privacy-policy");
      if (!res.ok) throw new Error("Failed to load Privacy Policy");
      return res.text();
    },
  });

  return (
    <div className="container max-w-3xl mx-auto py-12">
      <Card>
        <CardContent>
          {isLoading && <div>Loading...</div>}
          {error && <div className="text-red-500">Failed to load Privacy Policy.</div>}
          {markdown && <MarkdownRender content={markdown} />}
        </CardContent>
      </Card>
    </div>
  );
}
